import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './index.css';
import LandingApp from './LandingApp';


const container = document.getElementById('root');
const app = (
  <React.StrictMode>
    <LandingApp />
  </React.StrictMode>
);

if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}
